import { faCalendarStar } from '@fortawesome/pro-solid-svg-icons'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { DetailItem } from './DetailItem'

interface Props {
  holiday: Holiday
}

export const HolidayItem: FC<Props> = ({ holiday }) => {
  const { t } = useTranslation()

  return (
    <DetailItem
      icon={faCalendarStar}
      variant="holiday"
      heading={holiday.name}
      subheading={t('common.holiday')}
    />
  )
}
